// @ts-nocheck
// Gift message controller
document.addEventListener('DOMContentLoaded', function () {
	window.hasGiftMessage = window.hasGiftMessage || false;
	window.hasUnconfirmedGiftMessage = false;

	const giftMessageContainer = document.getElementById('eb_gift_message_cards');
	const giftMessageTextInput = document.querySelector('.eb-gift-message-text');
	const submitButton = document.querySelector('.eb-confirm-gift-message');
	const maxChars = 140;
	const openButtons = [...document.querySelectorAll('.gift-message__button')];

	window.openGiftMessage = function () {
		if (giftMessageContainer) {
			openButtons.forEach(button => {
				button.setAttribute('aria-expanded', 'true');
			});
			window.hasUnconfirmedGiftMessage = true;

			$(giftMessageContainer).slideDown(200, function () {
				document.body.classList.add('gift-message-open');
				const scrollTarget = giftMessageContainer.querySelector(
					'#select-card-design'
				);
				if (scrollTarget) {
					$('html, body').animate(
						{
							scrollTop:
								scrollTarget.getBoundingClientRect().top + window.scrollY - 100,
						},
						1000
					);
				}
			});
		}
	};

	window.closeGiftMessage = function () {
		if (giftMessageContainer) {
			openButtons.forEach(button => {
				button.setAttribute('aria-expanded', 'false');
			});
			window.hasUnconfirmedGiftMessage = false;

			$(giftMessageContainer).slideUp(200, function () {
				document.body.classList.remove('gift-message-open');
			});
		}
	};

	openButtons.forEach(function (button) {
		button.addEventListener('click', window.openGiftMessage);
	});
	[...document.querySelectorAll('.eb-cancel-gift-message')].forEach(function (
		button
	) {
		button.addEventListener('click', window.closeGiftMessage);
	});
	[...document.querySelectorAll('.return-to-shop')].forEach(function (button) {
		button.addEventListener('click', function (event) {
			if (window.hasUnconfirmedGiftMessage) {
				event.preventDefault();
				alert('Please confirm or cancel your gift message.');
			}
		});
	});

	// Limit gift message length
	if (giftMessageTextInput) {
		function onGiftMessageInput() {
			const remaining = Math.max(
				maxChars - giftMessageTextInput.value.length,
				0
			);
			giftMessageTextInput.value = giftMessageTextInput.value.substring(
				0,
				maxChars
			);
			const giftMessageLength =
				giftMessageTextInput.parentElement.querySelector('.eb-char-remaining');
			if (giftMessageLength) {
				giftMessageLength.innerText = `${remaining} character${
					remaining === 1 ? '' : 's'
				}`;
			}
		}
		giftMessageTextInput.addEventListener('input', onGiftMessageInput);
		onGiftMessageInput(); // Run once to sync
	}

	function selectVariant(variantId) {
		if (giftMessageContainer) {
			giftMessageContainer.dataset.selectedGiftCardId = variantId;
			[...giftMessageContainer.querySelectorAll('.gift-card-variant')].forEach(
				variant => {
					variant.classList.remove('selected');
					if (variant.dataset.variantId === variantId) {
						variant.classList.add('selected');
					}
				}
			);
			// Scroll to gift message input
			$(document.body).animate(
				{
					scrollTop:
						giftMessageTextInput.getBoundingClientRect().top +
						window.scrollY -
						100,
				},
				1000
			);
		}
	}

	// Select gift message card variant
	window.addEventListener('click', function (event) {
		let button = event.target;
		if (button.tagName !== 'BUTTON') {
			button = button.closest('button');
		}
		if (
			button &&
			button.className &&
			button.className.includes('eb-select-gift-variant') &&
			button.dataset &&
			button.dataset.variantId
		) {
			event.preventDefault();
			selectVariant(button.dataset.variantId);
		}
	});

	// Show individual card select popup
	if (giftMessageContainer) {
		[...giftMessageContainer.querySelectorAll('div[role="button"]')].forEach(
			button => {
				button.addEventListener('click', function (event) {
					const variantId = button.parentElement.dataset.variantId;
					Swal.fire({
						backdrop: true,
						allowOutsideClick: true,
						allowEscapeKey: true,
						buttonsStyling: false,
						showDenyButton: false,
						confirmButtonText: 'Select',
						showCloseButton: true,
						closeButtonHtml: window.closeButtonSVG,
						imageUrl: button.dataset.imageSrc,
						imageAlt: button.dataset.title,
						imageWidth: 500,
						customClass: {
							container: 'eb-updated',
							title: 'eb-body--mono fs-body--3 ln-medium text-center',
							confirmButton: 'button',
						},
					}).then(result => {
            // Force remove SWAL classes
            [document.documentElement, document.body].forEach(el => {
              el.classList.remove('swal2-shown');
              el.classList.remove('swal2-height-auto');
              el.style.paddingRight = '';                
            });
						if (result.isConfirmed) {
							selectVariant(variantId);
						}
					});
				});
			}
		);
	}

	// Move gift message container on resize/page load
	if (giftMessageContainer) {
		let _isDesktop = false;
		let _isMobile = false;
		const breakpoint = 768;
		const giftMessageTargetMobile = document.getElementById(
			'eb_gift_message_target_mobile'
		);
		const giftMessageTargetDesktop = document.getElementById(
			'eb_gift_message_target_desktop'
		);

		function moveGiftMessageContainer() {
			if (!_isMobile && window.innerWidth < breakpoint) {
				if (giftMessageTargetMobile) {
					giftMessageTargetMobile.appendChild(giftMessageContainer);
				}
				_isDesktop = false;
        _isMobile = true;
			} else if (!_isDesktop && window.innerWidth >= breakpoint) {
				if (giftMessageTargetDesktop) {
					giftMessageTargetDesktop.appendChild(giftMessageContainer);
				}
				_isDesktop = true;
        _isMobile = false;
			}
		}
		window.addEventListener('resize', moveGiftMessageContainer);
		moveGiftMessageContainer();
	}

	// Add/update gift message card
	if (submitButton) {
		submitButton.addEventListener('click', async function () {
			if (giftMessageContainer) {
				const selectedId = giftMessageContainer.dataset.selectedGiftCardId;
				const previousId = giftMessageContainer.dataset.currentGiftCardId;
				const previousKey = giftMessageContainer.dataset.currentGiftCardKey;
				if (selectedId) {
					const message = giftMessageTextInput.value;
					if (message) {
						// Remove previous card if set
						if (previousId) {
							this.innerText = 'Updating gift card...';
							await Alpine.store('cart').removeItem(
								{ key: previousKey },
								false
							);
						} else {
							this.innerText = 'Adding gift card...';
						}
						window.hasUnconfirmedGiftMessage = false;
						window.hasGiftMessage = true;
						await Alpine.store('cart').addItem(selectedId, 1, { message });
						location.reload();
					} else {
						alert('Please write your message.');
					}
				} else {
					alert('Please select a gift card design.');
				}
			}
		});
	}
});
